import React from 'react'
import styles from './groups-table.styles'
import injectSheet from 'react-jss'
import { Table, HeadCell } from 'pobble-components/dist/table'
import GroupEntry from './group-entry/group-entry.container'
import BookIcon from 'react-icons/lib/fa/book'
import EyeIcon from 'react-icons/lib/fa/eye'
import CommentLeftIcon from '../../../icons/comment-left-icon'
import CommentReceivedIcon from '../../../icons/comment-received-icon'

const GroupsTable = ({
  style,
  classes,
  allAction,
  sortBy,
  changeSortKey,
  groups,
  onSelect,
  selectedGroups,
  onGroupClick,
  hideAllButton,
  actualGroupsEmpty,
  filteredGroupsEmpty
}) => (
  <div style={style} className={classes.container}>
    {actualGroupsEmpty && <span>This school doesn't have any groups yet</span>}
    {filteredGroupsEmpty && <span>No groups matching this criteria</span>}
    {!!groups.length && (
      <Table className={classes.table}>
        <thead>
          <tr>
            <HeadCell>
              {!hideAllButton && (
                <span className={classes.selectAll} onClick={allAction}>
                  All
                </span>
              )}
            </HeadCell>
            <HeadCell
              ordered={sortBy.key === 'title' ? sortBy.direction : null}
              order={direction => changeSortKey('title', direction)}>
              Title
            </HeadCell>
            <HeadCell
              ordered={sortBy.key === 'access' ? sortBy.direction : null}
              order={direction => changeSortKey('access', direction)}>
              Access
            </HeadCell>
            <HeadCell
              ordered={
                sortBy.key === 'students_count' ? sortBy.direction : null
              }
              order={direction => changeSortKey('students_count', direction)}>
              Pupils
            </HeadCell>
            <HeadCell>
              <BookIcon />
            </HeadCell>
            <HeadCell>
              <CommentLeftIcon className={classes.icon} />
            </HeadCell>
            <HeadCell>
              <CommentReceivedIcon className={classes.icon} />
            </HeadCell>
            <HeadCell>
              <EyeIcon />
            </HeadCell>
            <HeadCell />
          </tr>
        </thead>
        <tbody>
          {groups.map(group => (
            <GroupEntry
              onClick={() => onGroupClick(group.id)}
              key={group.id}
              id={group.id}
            />
          ))}
        </tbody>
      </Table>
    )}
  </div>
)

export default injectSheet(styles)(GroupsTable)
